import React, {Fragment} from 'react'
import {Text, View, StyleSheet } from '@react-pdf/renderer';
const AmountContainer = ({data}) => {
    const styles = StyleSheet.create({
        titleContainer: {
            width : '100%',
            backgroundColor : '#E4E4E4',
            paddingBottom : '5px',
            paddingTop : '10px',
            paddingRight : '15px',
            marginTop: '10px',
            marginBottom: '5px',
            flexDirection: 'row',
            justifyContent:'flex-end',
            alignItems: 'center',
        },
        title: {
            fontSize: '11px',
            fontWeight: '500',
            color: '#333333',
            marginRight: "10px"
        }
    });
  return (
    <Fragment>
    <View style={styles.titleContainer}>
        <Text style={styles.title}>Advance Amount :</Text>
        <Text style={styles.title}>Rs. {data?.amount}</Text>
    </View>
    </Fragment>
  )
}

export default AmountContainer;